import(/* webpackMode: "eager", webpackExports: ["DeferredAnalytics"] */ "/opt/build/repo/app/_deferred/DeferredAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredWidgets"] */ "/opt/build/repo/app/_deferred/DeferredWidgets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/opt/build/repo/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/build/repo/app/shared/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ErrorFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/hero/PageHero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/nav/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/popup/AdmissionPopup.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/whatsapp-chat/WhatsApp-Chat.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/button.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/not-found.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Be_Vietnam_Pro\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"style\":[\"normal\",\"italic\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"ProjectFont\"}");
